import { useContext } from 'react';
import AvatarContext from '../contexts/AvatarContext';

const useAvatar = () => useContext(AvatarContext);

export default useAvatar;
